import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, Infinity, CreditCard } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PaymentIcons } from './PaymentIcons';
interface StackItem {
  icon: React.ElementType;
  title: string;
  description?: string;
  value: string;
  isMain?: boolean;
}
const stackItems: StackItem[] = [{
  icon: BookOpen,
  title: 'Libro Principal: El Código Maestro',
  value: '$29.00',
  isMain: true
}, {
  icon: Gift,
  title: 'BONUS 1: GUÍA DE SUPLEMENTOS',
  description: 'Qué tomar para una erección firme y duradera.',
  value: '$10.00'
}, {
  icon: Gift,
  title: 'BONUS 2: RECUPERA TU FIRMEZA',
  description: 'Cómo elevar tu testosterona de forma natural y segura.',
  value: '$15.00'
}, {
  icon: Gift,
  title: 'BONUS 3: LA DIETA DE LA DUREZA',
  description: 'Alimentos que funcionan como un potenciador natural.',
  value: '$9.00'
}, {
  icon: Gift,
  title: 'BONUS 4: CHEQUEO MAESTRO',
  description: 'Entiende tus análisis de sangre sin complicaciones.',
  value: '$9.00'
}, {
  icon: Gift,
  title: 'BONUS 5: DESCARGA DE PODER',
  description: 'Guía para mejorar cantidad, sabor y densidad.',
  value: '$7.80'
}];
export function ValueStack() {
  return <section className="py-24 bg-brand-darker relative border-t border-brand-cardBorder" data-id="element-232">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-234">
          <div className="inline-block px-4 py-1.5 rounded-full border border-brand-gold/30 bg-brand-gold/10 text-brand-gold text-sm font-semibold tracking-wide mb-6 uppercase" data-id="element-235">
            Arquitectura de Valor
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-236">
            Hoy no solo compras un libro. <br className="hidden sm:block" data-id="element-237" />
            <span className="text-brand-gold italic" data-id="element-238">
              Adquieres el sistema completo.
            </span>
          </h2>
          <p className="text-brand-muted text-lg max-w-2xl mx-auto" data-id="element-239">
            Al tomar acción en esta página, desbloqueas el arsenal completo para
            transformar tu virilidad de raíz.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="bg-brand-card border border-brand-gold/20 rounded-2xl p-6 sm:p-10 shadow-[0_0_40px_rgba(212,162,76,0.05)]" data-id="element-240">
          {/* Stack list */}
          <div className="space-y-3 mb-8" data-id="element-241">
            {stackItems.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.05 * index,
            duration: 0.4
          }} className="flex items-center justify-between p-4 rounded-lg bg-brand-dark border border-brand-cardBorder gap-4 hover:border-brand-gold/30 transition-colors" data-id="element-242">
                <div className="flex items-center gap-4 min-w-0" data-id="element-243">
                  <div className={`w-10 h-10 rounded-lg flex-shrink-0 flex items-center justify-center border ${item.isMain ? 'bg-brand-gold/15 border-brand-gold/40' : 'bg-brand-gold/5 border-brand-gold/15'}`} data-id="element-244">
                    <item.icon className={`w-5 h-5 ${item.isMain ? 'text-brand-gold' : 'text-brand-gold/70'}`} data-id="element-245" />
                  </div>
                  <div className="min-w-0 flex flex-col" data-id="element-246">
                    <span className={`text-sm sm:text-base ${item.isMain ? 'text-white font-bold' : 'text-brand-text/90 font-semibold'}`} data-id="element-247">
                      {item.title}
                    </span>
                    {item.description && <span className="text-xs sm:text-sm text-brand-muted/90 mt-0.5 leading-snug" data-id="element-248">
                        {item.description}
                      </span>}
                  </div>
                </div>
                <span className="text-brand-muted text-sm sm:text-base whitespace-nowrap font-medium" data-id="element-249">
                  <span className="hidden sm:inline" data-id="element-250">Precio Regular: </span>
                  <span className="text-brand-text/70" data-id="element-251">{item.value}</span>
                </span>
              </motion.div>)}
          </div>

          {/* Total real value */}
          <div className="flex items-center justify-between py-5 px-4 rounded-lg bg-brand-dark/50 border border-dashed border-brand-cardBorder mb-8" data-id="element-252">
            <span className="text-base sm:text-lg font-bold text-white uppercase tracking-wide" data-id="element-253">
              Valor Total Real:
            </span>
            <span className="text-2xl sm:text-3xl text-brand-crimson font-bold line-through decoration-2 decoration-brand-crimson/70" data-id="element-254">
              $79.80 USD
            </span>
          </div>

          {/* Launch offer banner */}
          <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="relative border border-brand-gold/40 rounded-xl p-6 sm:p-8 bg-gradient-to-br from-brand-gold/10 via-brand-card to-brand-card text-center overflow-hidden" data-id="element-255">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-gold to-transparent" data-id="element-256"></div>
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-257"></div>

            <div className="relative z-10" data-id="element-258">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-crimson/20 border border-brand-crimson/40 text-brand-crimson text-xs sm:text-sm font-bold tracking-wider mb-4 uppercase" data-id="element-259">
                🏷️ Oferta Especial · 75% de Descuento Adicional
              </div>

              <p className="text-brand-text/80 text-sm sm:text-base mb-6 max-w-xl mx-auto" data-id="element-260">
                Sabemos que la salud masculina es una prioridad que no puede
                esperar. Aprovecha este descuento especial y llévate el
                protocolo completo por una fracción de su valor.
              </p>

              <div className="mb-2" data-id="element-261">
                <span className="block text-sm sm:text-base text-brand-text/80 font-medium mb-2 uppercase tracking-widest" data-id="element-262">
                  Llévatelo todo por solo:
                </span>
                <span className="text-6xl sm:text-7xl font-serif font-bold text-brand-gold drop-shadow-[0_0_15px_rgba(212,162,76,0.4)] leading-none" data-id="element-263">
                  $19.99
                  <span className="text-3xl text-brand-gold/70 align-top ml-2" data-id="element-264">
                    USD
                  </span>
                </span>
              </div>

              <div className="flex items-center justify-center gap-2 text-brand-muted text-xs sm:text-sm mt-3 mb-8" data-id="element-265">
                <Infinity className="w-4 h-4 text-brand-gold" data-id="element-266" />
                <span data-id="element-267">Pago único · Sin suscripciones · Acceso de por vida</span>
              </div>

              <CtaButton text="SÍ, QUIERO EL CÓDIGO MAESTRO CON EL 75% DE DESCUENTO" className="max-w-2xl mx-auto" data-id="element-268" />

              <div className="flex items-center justify-center gap-2 mt-6 text-xs text-brand-muted" data-id="element-269">
                <CreditCard className="w-4 h-4 text-brand-gold/70" data-id="element-270" />
                <span data-id="element-271">
                  Aceptamos tarjetas de crédito, débito y PayPal vía Shopify
                  Secure
                </span>
              </div>

              <PaymentIcons data-id="element-272" />
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}